import _ from 'lodash';
import UrlBuilder from './UriBuilder';

/**
 * Utility for building URLs to pages.
 *
 * @author Adam Ayres
 */
export default class UrlManager {
  static BOARD_ID = 'board-id';

  static USER_ID_PARAM = 'user-id';

  static NODE_DISPLAY_ID_PARAM = 'node-display-id';

  static CROP_IMAGE_PARAM = 'crop-image';

  static IMAGE_SIZE_PARAM = 'image-size';

  static IMAGE_DIMENSIONS_PARAM = 'image-dimensions';

  static CHOOSE_NODE = 'choose-node';

  static INTERACTION_STYLE = 'interaction-style';

  static adjustImageServerPageUrl(url, crop, { width, height } = {}) {
    const urlBuilder = UrlBuilder.fromUrl(url);
    if (crop) {
      urlBuilder.addPath(UrlManager.CROP_IMAGE_PARAM, 'true');
    }
    if (width && height) {
      urlBuilder.removePath(UrlManager.IMAGE_SIZE_PARAM);
      urlBuilder.addPath(UrlManager.IMAGE_DIMENSIONS_PARAM, `${width}x${height}`);
    }
    return urlBuilder.build();
  }

  static addNodeIfNotCommunity(urlBuilder, node) {
    if (_.has(node, 'id') && node.id.split(':')[0] !== 'community') {
      urlBuilder.addPath(UrlManager.NODE_DISPLAY_ID_PARAM, node.id);
    }
  }

  constructor(globals) {
    this.globals = globals;
  }

  getPostPageUrl(
    { conversation_style: conversationStyle, id, node_type: nodeType },
    chooseNode,
    interactionStyle
  ) {
    const nodeId = _.replace(id, `${nodeType}:`, '');
    const urlBuilder = UrlBuilder.fromGlobals(this.globals);

    if (conversationStyle === 'tkb') {
      urlBuilder.addPath('tkb', 'choosetemplatepage');
    } else if (interactionStyle === 'occasion' || conversationStyle === 'occasion') {
      urlBuilder.addPath('occasions', 'createoccasionpage');
    } else {
      urlBuilder.addPath('forums', 'postpage');
    }

    if (nodeType === 'board') {
      urlBuilder.addPath(UrlManager.BOARD_ID, nodeId);
    } else {
      urlBuilder.addPath(UrlManager.NODE_DISPLAY_ID_PARAM, id);
    }

    if (chooseNode === true) {
      urlBuilder.addPath(UrlManager.CHOOSE_NODE, 'true');
    }

    if (interactionStyle) {
      urlBuilder.addPath(UrlManager.INTERACTION_STYLE, interactionStyle);
    }
    return urlBuilder.build();
  }

  getGroupHubsPageUrl({ user, node } = {}) {
    const urlBuilder = UrlBuilder.fromGlobals(this.globals);
    urlBuilder.addPath('grouphubs', 'page');

    if (_.has(user, 'id')) {
      urlBuilder.addPath(UrlManager.USER_ID_PARAM, user.id);
    }
    UrlManager.addNodeIfNotCommunity(urlBuilder, node);

    return urlBuilder.build();
  }

  getGroupHubCreatePage(node) {
    const urlBuilder = UrlBuilder.fromGlobals(this.globals);
    urlBuilder.addPath('grouphubs', 'grouphubcreatepage');
    UrlManager.addNodeIfNotCommunity(urlBuilder, node);
    return urlBuilder.build();
  }
}
